interface HasUuid {
  uuid?: unknown;
}

export default function filterByReference<T>(
  arr1: readonly T[] | undefined | null,
  arr2: readonly T[] | undefined | null,
): T[] {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- value is present by contract here but the GraphQL type is nullable; re-type from codegen to remove
  const content = arr1!.filter((el) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- value is present by contract here but the GraphQL type is nullable; re-type from codegen to remove
    return arr2!.every((element) => {
      return (element as HasUuid).uuid !== (el as HasUuid).uuid;
    });
  });
  return content;
}
